
export { TabNames } from "/home/runner/work/capsicum/capsicum/libs/features/wallet/shared/src/models/wallet.ts"